import React from 'react';
import {useTranslation} from 'react-i18next';
import {SpecificationViewData} from '../../../models/specificationViewer';

type SectionPackingProps = {
    spec: SpecificationViewData;
}

type BoolCommentRowProps = {
    value: boolean;
    label: string;
    comment: string | null;
}

const BoolCommentRow: React.FC<BoolCommentRowProps> = ({value, label, comment}) => (
    <div className="bool-row">
        <div className={`bool-indicator ${value ? 'yes' : 'no'}`}>
            {value ? '\u2713' : '\u2717'}
        </div>
        <div>
            <div className="bool-label">{label}</div>
            {value && comment && <div className="bool-comment">{comment}</div>}
        </div>
    </div>
);

const SectionPacking: React.FC<SectionPackingProps> = ({spec}) => {
    const {t} = useTranslation();

    return (
        <div>
            <BoolCommentRow value={spec.packingFull} label={t('specificationViewer.packingFull')} comment={null}/>
            <BoolCommentRow value={spec.packingOriginal} label={t('specificationViewer.packingOriginal')} comment={null}/>
            <BoolCommentRow value={spec.packingDedicated} label={t('specificationViewer.packingDedicated')} comment={null}/>
            <BoolCommentRow value={spec.marking} label={t('specificationViewer.marking')} comment={spec.markingComment}/>
            <BoolCommentRow value={spec.particularContainersDefects} label={t('specificationViewer.particularContainersDefects')} comment={spec.particularContainersDefectsComment}/>
            <BoolCommentRow value={spec.particularDeliveriesDefects} label={t('specificationViewer.particularDeliveriesDefects')} comment={spec.particularDeliveriesDefectsComment}/>
            <BoolCommentRow value={spec.defectsPhotos} label={t('specificationViewer.defectsPhotos')} comment={spec.defectsPhotosComment}/>
            <BoolCommentRow value={spec.labelsPhotos} label={t('specificationViewer.labelsPhotos')} comment={spec.labelsPhotosComment}/>
            <BoolCommentRow value={spec.detailMeasureResults} label={t('specificationViewer.detailMeasureResults')} comment={spec.detailMeasureResultsComment}/>
        </div>
    );
};

export default SectionPacking;
